import React, {Component} from "react";
import {request} from "./helper/APIUtils";
import {showAxiosError} from "./helper/helper";
import {Container} from "react-bootstrap";
import {Col, Row} from "reactstrap";
import {SERVLET_PATH} from "./constants";
import NumberFormat from "react-number-format";
import {Decimal} from "decimal.js";
import Datetime from "react-datetime";
import moment from "moment";
import 'react-datetime/css/react-datetime.css';
import Alert from "react-s-alert";
import MediaViewer from "./accounting/einvoice/MediaViewer";

class GetEAInvoice extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sourceId:"",
			documentIssueDate:"",
			documentId:"",
			total: new Decimal(0).toNumber().toString(),
			documentUuid:"",
			processing:false,
			processingPdf: false,
			processingXml: false,
			mediaModal: false,
			url: null,
			isDisabled: false
		};
	}

	componentDidMount = () => {
		let self = this;
		const matchParams = self.props.match.params;

		if ((matchParams.uuid || matchParams.year || matchParams.month) ||
			(self.state.sourceId || self.state.documentId || self.state.documentIssueDate)) {
			this.setState({ isDisabled: true });
		}

		if (matchParams.uuid || matchParams.year || matchParams.month) {
			let url = this.setUrlToInfo(this.props.type);

			if (matchParams.year) {
				url += "/" + matchParams.year;
			}

			if (matchParams.month) {
				url += "/" + matchParams.month;
			}

			let contentType = undefined;
			if (matchParams.contentType) {
				contentType = matchParams.contentType;
			}

			if (matchParams.uuid) {
				let uuid = matchParams.uuid;
				if (matchParams.uuid.includes(".pdf")) {
					contentType = "show";
					uuid = uuid.replace(".pdf", "");
				}
				url += "/" + uuid;
			}

			const params = {
				url: url,
				method: "get"
			};
			self.setState({ processing: true });

			request(params)
				.then(response => {
					let data = response.data;
					self.setStateFromResponse(data);
					if (contentType) {
						self.downloadContent(contentType);
					}
					if (data.sourceId || data.documentId || data.documentIssueDate) {
						self.setState({ isDisabled: true });
					}
				})
				.catch(function (error) {
					showAxiosError(error);
					self.setState({ processing: false });
				});
		}
	};
	onChangeDate = (momentObj) => {
		if (!(typeof momentObj === "string")) {
			this.setState({documentIssueDate: momentObj.format("YYYY-MM-DD")});
		}
	}

    downloadContent = (type) => {
        let self = this;

        if ((self.props.type.toLowerCase().indexOf("esigorta") !== 0) && (self.props.type.toLowerCase().indexOf("despatch") === -1 && (null === self.state.total || 0 === self.state.total || self.state.total === "0")) || (self.props.type.toLowerCase().indexOf("despatch") !== -1 && null === self.state.total)) {
            Alert.error((self.props.type.toLowerCase().indexOf("despatch") === -1 ? 'Tutar Boş veya 0 Olamaz.' : 'Tutar Boş Olamaz.'), {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        } else {
            if (self.state.sourceId && self.state.documentId && self.state.documentIssueDate) {
                let params = {
                    url: `${self.setUrlToDocument()}/${self.state.sourceId}/${self.state.documentId}/${self.state.documentIssueDate}/${self.state.total}/${type}`,
                    responseType: 'arraybuffer',
                    method: "get"
                };

                if (["pdf", "show"].includes(type)) {
                    self.setState({processingPdf: true});
                } else {
                    self.setState({processingXml: true});
                }

                request(params)
                    .then(function (response) {
                        if (type === "xml") {
                            let blob = new Blob([response.data], {type: response.headers["content-type"]});
                            let urlCreator = window.URL || window.webkitURL;
                            let url = urlCreator.createObjectURL(blob);
                            let a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            a.href = url;
                            a.download = self.state.documentId + ".xml";
                            a.click();
                            self.setState({processingXml: false});
                        } else if (type === "pdf") {
                            let blob = new Blob([response.data], {type: response.headers["content-type"]});
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = self.state.documentId + ".pdf";
                            document.body.appendChild(link);
                            link.click();
                            self.setState({processingPdf: false});
                        } else if (type === "show") {
                            let blob = new Blob([response.data], {type: response.headers["content-type"]});
                            let urlCreator = window.URL || window.webkitURL;
                            let url = urlCreator.createObjectURL(blob);
                            self.setState({url: url, mediaModal: true});
                        }
                    }).catch(function (error) {
                    showAxiosError(error);
                    if (["pdf", "show"].includes(type)) {
                        self.setState({processingPdf: false});
                    } else {
                        self.setState({processingXml: false});
                    }
                });
            } else {
                Alert.error('Boş alanları doldurunuz.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            }
        }
    }
	setTotal(value){
		if(value.length > 0){
			this.setState({"total":(new Decimal(value)).toNumber()})
		}
		else{
			this.setState({"total":null})
		}
	}

	setUrlToInfo = (type) => {
		let url = "";
		if (type === "voucher")
			url = `/store/getEVoucherInfo`;
		else if (type === "inboxDespatch")
			url = `/store/getInboxEDespatchInfo`;
		else if (type === "outboxDespatch")
			url = `/store/getOutboxEDespatchInfo`;
		else if (type === "earchive")
			url = `/store/getEAInfo`;
		else if (type === "inboxInvoice")
			url = `/store/getInboxEInvoiceInfo`;
		else if (type === "outboxInvoice")
			url = `/store/getOutboxEInvoiceInfo`;
		else if (type === "receipt")
			url = `/store/getEReceiptInfo`;
		else if (type === "eexchange")
			url = `/store/getEExchangeInfo`;
		else if (type === "expenseNote")
			url = `/store/getExpenseNoteInfo`;
		else if (type === "esigorta")
			url = `/store/getSigortaInfo`;
		return url;
	}

	setUrlToDocument = (type) =>{
		let self = this;
		let documentType = type ? type : self.props.type;
		let url = "";
		if (documentType === "voucher") {
			url = `/store/getEVoucherDocument`;
		} else if (documentType === "inboxDespatch") {
			url = "/store/getInboxEDespatchDocument";
		} else if (documentType === "outboxDespatch") {
			url = `/store/getOutboxEDespatchDocument`;
		} else if (documentType === "earchive") {
			url = `/store/getEarchiveDocument`;
		} else if (documentType === "inboxInvoice") {
			url = `/store/getInboxEInvoiceDocument`;
		} else if (documentType === "outboxInvoice") {
			url = `/store/getOutboxEInvoiceDocument`;
		} else if (documentType === "receipt"){
			url = `/store/getEReceiptDocument`;
		} else if (documentType === "eexchange"){
			url = `/store/getEExchangeDocument`;
		}else if (documentType === "expenseNote"){
			url = `/store/getExpenseNoteDocument`
		}else if (documentType === "esigorta"){
			url = `/store/getSigortaDocument`
		}

		return url;
	}

	setStateFromResponse = (data) => {
		let self = this;
		const type = self.props.type;
		let total = null;
		self.setState({
			sourceId: data.sourceId,
			documentIssueDate: data.documentIssueDate,
			documentId: data.documentId,
			documentUuid: data.documentUuid,
			processing: false,
			cancelled: data.cancelled,
			cancelReason: data.cancelReason,
			cancelDate: data.cancelDate
		})
		if (type === "voucher") {
			total = data.documentTotal;
		} else if (type === "earchive") {
			total = data.invoiceTotal;
		} else if (type.includes("Despatch")) {
			total = data.despatchTotal;
		} else if (type.includes("Invoice")) {
			total = data.invoiceTotal;
		} else if (type === "receipt") {
			total = data.documentTotal;
		} else if (type === "eexchange") {
			total = data.documentTotal;
		} else if(type === "expenseNote"){
			total = data.documentTotal;
		} else if(type === "esigorta"){
			total = data.documentTotal;
		}

		self.setState({total});
	}

	showDocumentType = (isPrice = false) => {
		let self = this;
		let type = self.props.type;
		let documentType = "";
		if (type === "earchive" || type.includes("Invoice")) {
			documentType = "Fatura";
		} else if (type.includes("Despatch")) {
			documentType = "İrsaliye"
		} else if (type === "voucher") {
			if (isPrice) {
				documentType = "Makbuz Tutarı/Brüt Ücret "
			} else {
				documentType = "Makbuz";
			}
		} else if (type.includes("receipt")) {
			documentType = "Adisyon"
		}else if (type.includes("eexchange")){
			documentType = 'Döviz'
		}else if (type.includes("expenseNote")){
			documentType = "Gider Pusulası"
		} else if (type.includes("esigorta")){
			documentType = "Sigorta"
		}
		return documentType;
	}

	closeMediaViewer = () => {
		let self = this;
		self.setState({url: null, mediaModal: false, processingPdf: false});
	}

	render = () => {
		let self = this;
		return (
			<Container style={{marginTop: '9%', padding: '0 25px 0 25px'}}>
				<Row>
					<Col xs="12" style={{textAlign: 'center', marginBottom: '5%'}}>
						<img src={SERVLET_PATH + "/api/virtual/resource/login.png"}/>
					</Col>
				</Row>

				<Row>
					<Col xs="12" className="input-container">
						<Row style={{padding: '0 15px 0 15px'}}>
							<Col xs="12" sm="6" style={{padding: '0 40px 0 40px'}}>
								<Row style={{marginBottom: '20px'}}>
									<Col xs='12'>
										<label className="col-form-label">Satıcı VKN/TCKN</label>
									</Col>

									<Col xs='12'>
										<input className='form-control'
                                               id="sourceId"
                                               maxLength="11"
                                               onChange={(e)=>self.setState({"sourceId": e.target.value})}
                                               value={self.state.sourceId}
											   disabled={self.state.isDisabled}/>
									</Col>
								</Row>
							</Col>

							<Col xs="12" sm="6" style={{padding: '0 40px 0 40px'}}>
								<Row style={{marginBottom: '20px'}}>
									<Col xs='12'>
										<label className="col-form-label">{self.showDocumentType()} Numarası</label>
									</Col>

									<Col xs='12'>
										<input className='form-control'
											   id="documentId"
											   maxLength="16"
											   onChange={(e)=>self.setState({"documentId": e.target.value})}
											   value={self.state.documentId}
											   disabled={self.state.isDisabled}/>
									</Col>
								</Row>
							</Col>
						</Row>

						<Row style={{padding: '0 15px 0 15px'}}>
							<Col xs="12" sm="6" style={{padding: '0 40px 0 40px'}}>
								<Row style={{marginBottom: '20px'}}>
									<Col xs='12'>
										<label className="col-form-label">{self.showDocumentType()} Tarihi</label>
									</Col>

									<Col xs='12'>
										<Datetime locale="tr"
												  className="datepicker"
												  input={true}
												  inputProps={{id: 'documentIssueDate', disabled: self.state.isDisabled}}
												  closeOnSelect={true}
												  value={moment(self.state.documentIssueDate)}
												  defaultValue={moment()}
												  dateFormat="DD-MM-YYYY"
												  timeFormat={false}
												  isValidDate={function (current) {
													  return current.isBefore(Datetime.moment());
												  }}
												  onChange={(e) => self.onChangeDate(e, "documentIssueDate")}/>
									</Col>
								</Row>
							</Col>

							<Col xs="12" sm="6" style={{padding: '0 40px 0 40px'}}>
								<Row style={{marginBottom: '20px'}}>
									<Col xs='12'>
										<label
											className="col-form-label">{self.showDocumentType(true) + " Tutarı"}</label>
									</Col>

									<Col xs='12'>
										<NumberFormat id="total"
													  value={self.state.total}
													  allowNegative={false}
													  isNumericString={true}
													  allowEmptyFormatting={false}
													  decimalScale={4}
													  thousandSeparator={'.'}
													  decimalSeparator={','}
													  displayType="input"
													  placeholder=""
													  renderText={value => {
														  value.replace(/\./g, ',')
													  }}
													  onValueChange={(e) => self.setTotal(e.value)}
													  className="form-control"
													  disabled={self.state.isDisabled}/>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>

				<Row style={{marginTop: '20px'}}>
					<Col xs='3'/>
					<Col xs='3' style={{textAlign: 'center'}}>
						<button className="flex-button" style={{width: '100%'}} disabled={self.state.processingPdf || self.state.processingXml} onClick={()=>self.downloadContent("pdf")}>
							{!self.state.processingPdf ? 'PDF İndir' : <i className="fa fa-spinner fa-spin"/>}
						</button>
					</Col>

					<Col xs='3' style={{textAlign: 'center'}}>
						<button className="flex-button" style={{width: '100%'}} disabled={self.state.processingXml || self.state.processingPdf} onClick={()=>self.downloadContent("xml")}>
							{!self.state.processingXml ? 'XML İndir' : <i className="fa fa-spinner fa-spin"/>}
						</button>
					</Col>
					<Col xs='3'/>
				</Row>
				{self.state.cancelled === 1 &&
				<Row style={{marginTop: '20px'}}>
					<Col sm='12' md='12' lg='12' style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>
						<label className='errorMessage'>{self.state.cancelDate.toString().substring(0, 10)} tarihinde {self.state.cancelReason} sebebiyle iptal edilmiştir.</label>
					</Col>
				</Row> }

				{self.state.mediaModal &&
					<MediaViewer modal={self.state.mediaModal}
								 url={self.state.url}
								 title={self.state.documentId}
								 listener={self.closeMediaViewer}
								 selectedItem={self.state.selectedItem}
								 location='publicQueryDocuments'
					/>
				}

			</Container>);
	}
}

export default GetEAInvoice;